import $ from "jquery";

if (document.querySelector(".dropdown-filter")) {
    $(".dropdown-filter select").select2({
        minimumResultsForSearch: Infinity,
        dropdownParent: $(".dropdown-filter__select")
    });
}